module.exports = __webpack_public_path__ + "img/audit-prefoter.2de3e82.svg";